import Auth from "../Auth";
import axios from "axios";
import constant from "../../configs/constant";
import jwt_decode from "jwt-decode";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import history from "../Navigation";
import moment from "moment";

const URL = constant.serverUrl;

const MySwal = withReactContent(Swal);

const serverCall = async (config) => {
  //header authorization
  // const token = config.acsessType;
  var original = constant.appVersions;
  var appVersions = original.substr(original.indexOf("v") + 1);
  config.headers = {
    "Access-Control-Allow-Origin": "*",
    // "authorization": `Bearer ${token}`,
    "X-Application-Version": appVersions,
    "Content-Type": config.contentType,
    Accept: config.accept,
  };
  //interceptors handle network error
  await axios.interceptors.response.use(
    (response) => {
      return response;
    },
    function (error) {
      if (!error.response) {
        error.response = {
          data: "net work error",
          status: 500,
        };
      }

      return Promise.reject(error);
    }
  );
  config.baseURL = URL;
  return axios(config);
};

const serverCallOther = async (config) => {
  //header authorization
  const token = JSON.parse(localStorage.getItem("auth"));
  var original = constant.appVersions;
  var appVersions = original.substr(original.indexOf("v") + 1);
  config.headers = {
    // 'Access-Control-Allow-Origin':'*',
    Authorization: `Bearer ${token}`,
    "Content-Type": config.contentType,
    Accept: config.accept,
  };
  //interceptors handle network error
  await axios.interceptors.response.use(
    (response) => {
      var VersionsServer = response?.headers["x-application-version"];
      if (parseInt(appVersions) === parseInt(VersionsServer)) {
        return response;
      } else {
        caches.keys().then((names) => {
          names.forEach((name) => {
            caches.delete(name);
          });
        });
        Swal.fire({
          position: "middle",
          icon: "warning",
          title:
            "Great News !<br> Your application has been updated with new features since you last logged in. <br> Kindly wait while you are redirected to the login page",
          showConfirmButton: false,
          timer: 5000,
          width: 600,
          allowOutsideClick: false,
        });
        setInterval(function () {
          Auth.logout();
        }, 5000);
      }
    },
    function (error) {
      if (error.response.status === 401) {
        Auth.logout();
        throw error;
      }
      return Promise.reject(error);
    }
  );
  config.baseURL = URL;
  return axios(config);
};
// export default serverCall

export const Getlogin = (bodyData) => {
  var bodyDataMain = {
    username: bodyData.username,
    password: bodyData.password,
    scope: bodyData.scope,
  };
  var formBody = [];
  for (var submitData in bodyDataMain) {
    var encodedKey = encodeURIComponent(submitData);
    var encodedValue = encodeURIComponent(bodyData[submitData]);
    formBody.push(encodedKey + "=" + encodedValue);
  }

  formBody = formBody.join("&");
  return serverCall({
    method: "POST",
    url: "login/",
    data: formBody,
    accept: "application/json",
    contentType: "application/x-www-form-urlencoded;charset=UTF-8",
  })
    .then((res) => {
      if (res.status === 200) {
        var tokendata = res.data.access_token;
        var permissions = "";
        localStorage.setItem("auth", JSON.stringify(res.data.access_token));
        // sessionStorage.setItem('authpost', JSON.stringify(res.data.access_token));
        // Auth.setUserToken(res.data.access_token);
        var decoded = jwt_decode(res.data.access_token);
        var userpermisson = decoded.user_permissions;
        var user_tenant = decoded.user_tenant;
        var userpermissonData = [];
        var currentData = new Date();
        for (var i = 0; i < userpermisson.length; i++) {
          var ApplicationPermissions = userpermisson[i].ApplicationPermissions;
          for (var j = 0; j < ApplicationPermissions.length; j++) {
            var userpermissonMain = {};
            userpermissonMain.ApplicationCode =
              userpermisson[i].ApplicationCode;
            userpermissonMain.ApplicationPermissionValue =
              ApplicationPermissions[j].ApplicationPermissionValue;
            userpermissonMain.PermissionCode =
              ApplicationPermissions[j].PermissionCode;
            userpermissonData.push(userpermissonMain);
          }
        }
        var accsessData = {
          accesstoken: res.data.access_token,
          // userdata: decoded,
          tokendata: currentData,
          appver: constant.appVersions,
          // userpermisson: userpermisson,
        };
        localStorage.setItem("access_token", JSON.stringify(accsessData));
        //  localStorage.setItem('permissions',JSON.stringify(userpermissonData));
        localStorage.setItem("user_tenant", JSON.stringify(user_tenant));

        const filteredData = userpermissonData.filter((obj) => {
          return obj.PermissionCode === "LOGIN_BG";
        });
        if (filteredData.length > 0) {
          permissions = filteredData[0].PermissionCode;
        }
        if (user_tenant.length > 1) {
          if (permissions === "LOGIN_BG") {
            window.location.href = "/home";
          }
        } else {
          if (permissions === "LOGIN_BG") {
            window.location.href = "/home";
            var selected_tenant = {
              ApplicationTenantID: user_tenant[0].ApplicationTenantID,
              Tenant: user_tenant[0].Tenant,
            };
            localStorage.setItem(
              "selected_tenant",
              JSON.stringify(selected_tenant)
            );
          }
        }

        localStorage.setItem("access_token", JSON.stringify(accsessData));
        //  localStorage.setItem('permissions',JSON.stringify(userpermissonData));
        // window.location.href = constant.serverUrl+"create-job";
        return true;
      } else {
        MySwal.fire("<p>Incorrect username or password, please try again!<p>");
        return 1;
      }
    })
    .catch((err) => {
      const condition = navigator.onLine ? "online" : "offline";
      console.log("err", err);
      if (condition === "offline") {
        MySwal.fire(
          "<p>You are currently offline. Please connect to internet and try again!<p>"
        );
        return 1;
      } else {
        MySwal.fire("<p>Incorrect username or password, please try again!<p>");
        console.log(err.message);
        return 1;
      }
    });
};

export const getHomeRequest = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "bg/request/?ModifiedBy=" +
      bodyData.userId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getHomeBg = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "bg/bg/?ModifiedBy=" +
      bodyData.userId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getHomeSurrendered = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "bg/surrendered/?ModifiedBy=" +
      bodyData.userId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getHomeCancelled = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "bg/cancelled/?ModifiedBy=" +
      bodyData.userId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getHomeRenewed = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "bg/renewed/?ModifiedBy=" +
      bodyData.userId +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getSummary = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "bg/" +
      bodyData.UserID +
      "/bgsummary/?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
    acsessType: bodyData,
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackSelectionType = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "/common/selections/?selection_type=" +
      bodyData.selectionType +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackBgDetails = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "/bg/" +
      bodyData.ReqIDEnc +
      "/?UserID=" +
      bodyData.UserID +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/home";
        }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackSelectionImage = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url: "/bg/" + ApplicationTenantID + "/SelectionBGDocumets/",
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBGLog = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url: "/bg/" + bodyData.ReqIDEnc + "/bglogsdata/",
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/home";
        }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getUploadDetails = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url: "documents/?application_tenant_id=" + ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackBgPermission = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "/bg/" +
      bodyData.ReqIDEnc +
      "/permission/?UserID=" +
      bodyData.UserID +
      "&application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/home";
        }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackBgAllSites = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url:
      "/bg/" +
      bodyData.UserID +
      "/AllSites/" +
      "?application_tenant_id=" +
      ApplicationTenantID,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const getBackBgSapCust = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "GET",
    url: "/customers/sapcrm/?customer_type=" + bodyData.customer_type,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "/home";
        }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const documentsUpload = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "POST",
    url: "documents/upload/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "multipart/form-data",
    contentType: "multipart/form-data",
  })
    .then((res) => {
      if (res.status === 201) {
        // MySwal.fire('<p>Prospect has been cretated successfully<p>');
        return res.data;
      } else {
        // MySwal.fire('<p>Something went wrong, please try again<p>');
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const deleteImage = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "DELETE",
    url:
      "bg/" +
      bodyData.BGDocumentID +
      "/?application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been deleted successfully<p>");
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const createBgRequest = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "POST",
    url: "bg/?application_tenant_id=" + ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been added successfully<p>");
        return res.status;
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const updateBgRequest = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url:
      "bg/" +
      bodyData.reqID_enc +
      "/BGSave/?application_tenant_id=" +
      ApplicationTenantID,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
      return res.status;
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};

export const renewBgRequest = (bodyData) => {
  var ApplicationTenantID = 0;
  const accessselectedtentant = localStorage.getItem("selected_tenant");
  if (
    accessselectedtentant !== "" &&
    accessselectedtentant !== null &&
    accessselectedtentant !== undefined
  ) {
    const readDataSelected = JSON.parse(accessselectedtentant);
    ApplicationTenantID = readDataSelected.ApplicationTenantID;
  }
  return serverCallOther({
    method: "PUT",
    url:
      "bg/" +
      +bodyData.reqID +
      "/renew?newValidityTo=" +
      bodyData.ValidityTo +
      "&newClaimPeriod=" +
      bodyData.ClaimPeriod +
      "&modifiedBy=" +
      bodyData.ModifiedBy,
    data: bodyData,
    accept: "application/json",
    contentType: "application/json",
  })
    .then((res) => {
      if (res.status === 200) {
        MySwal.fire("<p>Data has been updated successfully<p>");
      } else {
        MySwal.fire("<p>Something went wrong, please try again<p>");
      }
      return res;
    })
    .catch((err) => {
      var msg = err.response.data.errors;
      Swal.fire({
        icon: "error",
        title: err.response.status,
        allowOutsideClick: false,
        text: msg,
      }).then((result) => {
        // if (result.isConfirmed) {
        //   window.location.reload();
        // }
      });
      // MySwal.fire('<p>Something went wrong, please try again<p>');
      console.log("err", err);
    });
};
